<script setup lang="ts">

import { computed } from '#imports';

type Props = {
    totalOwners?: number;
    isEvmErc1155?: boolean;
    isLoading?: boolean;
    items?: string;
    addressOwner?: string;
};

const { totalOwners = 0, items = '', isEvmErc1155, addressOwner, isLoading } = defineProps<Props>();
const emit = defineEmits(['onClick']);
const ownershipLabel = computed(() => totalOwners === 1 ? ' owner' : ' owners');
</script>

<template>
  <p class="compact-600-default color-text-grey display-flex gap-10">
    <template v-if="!!isEvmErc1155">
      <span v-if="!isLoading && items">{{items}}k items</span>
      <span>
        <span v-if="isLoading"
              class="text-color-brand-aviation">
          ...
        </span>
        <span v-else>
          <span class="text-color-brand-aviation cursor-pointer"
                @click="() => emit('onClick')">{{ totalOwners }}
          </span>
          <span>{{ ownershipLabel }}</span>
        </span>
      </span>
    </template>
    <template v-else-if="addressOwner">
      <NuxtLink :to="{path: `/profile/${addressOwner}`}"
                :prefetch="false"
      >
        Owned by <span class="text-color-brand-aviation">{{ toShortAddress(addressOwner) }}</span>
      </NuxtLink>
    </template>
  </p>
</template>
